module.exports = __webpack_public_path__ + "static/media/applause.e4577a49.mp3";